<script>
export default {
    name: "ApplicationFieldBorders",

    props: {
        geo: Array,
        drawType: {
            type: Number,
            default: 1,
            required: false,
        }
    },

    mounted() {
        this.drawCanvas(this.$refs.canvas);
    },

    methods: {
        drawCanvas: function (canvas) {

            let geo = this.geo;

            if (!geo || geo.length === 0) return

            if (Array.isArray(geo[0])){
                geo=geo[0]
            } else {
                geo = geo.map(f => [f.lat, f.lng]);
            }

            let ctx = canvas.getContext('2d')

            let minX, minY, maxX, maxY
            geo.forEach((p, i) => {
                if (i === 0) {
                    minX = maxX = p[0]
                    minY = maxY = p[1]
                } else {
                    minX = Math.min(p[0], minX)
                    minY = Math.min(p[1], minY)
                    maxX = Math.max(p[0], maxX)
                    maxY = Math.max(p[1], maxY)
                }
            })

            const mapWidth = maxX - minX
            const mapHeight = maxY - minY
            const mapCenterX = (maxX + minX) / 2
            const mapCenterY = (maxY + minY) / 2
            const scale = Math.min(canvas.width / mapWidth, canvas.height / mapHeight)

            ctx.beginPath()
            geo.forEach(p => {
                ctx.lineTo((p[0] - mapCenterX) * scale + canvas.width / 2, (p[1] - mapCenterY) * scale + canvas.height / 2)
            })
            ctx.lineTo((geo[0][0] - mapCenterX) * scale + canvas.width / 2, (geo[0][1] - mapCenterY) * scale + canvas.height / 2)
            ctx.strokeStyle = '#2C2A44'
            ctx.stroke()

            let mCanvas = document.createElement('canvas')
            mCanvas.width = canvas.width
            mCanvas.height = canvas.height

            let mctx = mCanvas.getContext('2d')
            mctx.drawImage(canvas, 0, 0)

            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.translate(25, 25)

            const radians = (280 / 180) * Math.PI
            ctx.rotate(radians)

            let widthModifier = 2;
            let heightModifier = 2;

            if(this.drawType === 2) {
                widthModifier = 4;
                heightModifier = 1.15;
            }

            ctx.drawImage(mCanvas, -canvas.width / widthModifier, -canvas.height / heightModifier);

            ctx.rotate(-radians)
            ctx.translate(-canvas.width / widthModifier, -canvas.height / heightModifier)
        }
    },
}
</script>

<style scoped>

</style>
